import getRandomPfp from "@/utils/getRandomPfp";
import Image from "next/image";
import SolanaIcon from "@/assetsV2/Marketplace/SolanaIcon";
import { IGCCHoldings } from "@/types/IGCCHoldings";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import MyTooltip from "@/components/Common/MyTooltip";
import InfoIcon from "@/assetsV3/profile/Info";

export const ReviewStep = ({
  selectedGcc,
  displayAmount,
  displayPrice,
  gasFee,
}: {
  selectedGcc: IGCCHoldings | undefined;
  displayAmount: string;
  displayPrice: string;
  gasFee: number
}) => {
  return (
    <div className="flex gap-[8px] flex-col p-6">
      <span className="text-[28px] font-bold text-outext-main font-inter">
        Review
      </span>
      <span className="text-base text-outext-sub font-normal">
        Summary of your transaction.
      </span>
      {selectedGcc ? (
        <div className="flex flex-col gap-[34px] mt-[10px]">
          {selectedGcc.subject ?
            <div className="flex flex-row gap-6">
              <Image
                height={60}
                width={60}
                src={
                  selectedGcc.subject
                    ? selectedGcc.subject.profilePic
                    : getRandomPfp()
                }
                alt="test"
                className="rounded-full h-[60px]"
                onError={async ({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = getRandomPfp();
                }}
              />
              <div className="flex flex-col">
                <p className="text-[16] text-outext-main font-[700] ">
                  {selectedGcc.subject.displayName}
                </p>
                <p className="text-[16px] text-outext-sub font-[500] ">
                  @{selectedGcc.subject.handle}
                </p>
              </div>
            </div>
            :
            <SkeletonTheme baseColor="#373737" highlightColor="#C0C0C0">
              <div className="flex flex-row items-center gap-6">
                <Skeleton circle={true} height={48} width={48} />
                <Skeleton height={20} width={100} style={{ borderRadius: '8px' }} />
              </div>
            </SkeletonTheme>

          }
          <div className="flex gap-6">
            <div className="flex flex-col w-full  justify-between">
              <div className="flex justify-between py-3">
                <span className="text-outext-main font-normal">Chips Amount</span>
                <div className="flex gap-[4px] text-outext-sub items-center">
                  <span>{displayAmount}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-outext-main font-normal">Price Per Chip</span>
                <div className="flex gap-[4px] text-outext-sub items-center">
                  <SolanaIcon
                    width={20}
                    height={20}
                    className="fill-outicon-sub"
                  />
                  <span>{displayPrice}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-outext-main font-normal">Estimated Fee</span>
                <div className="flex gap-[4px] text-outext-sub items-center">
                  <SolanaIcon
                    width={20}
                    height={20}
                    className="fill-outicon-sub"
                  />
                  <span>{gasFee}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-outext-main flex gap-1 justify-start items-start">Total
                  <MyTooltip message="A 7% fee divided equally between creators will be deducted once sold">
                    <InfoIcon width={"10px"} height={"10px"} className="fill-outext-main" />
                  </MyTooltip>
                </span>
                <div className="flex gap-[4px] items-center">
                  <SolanaIcon
                    className="fill-outstate-whitecompact"
                    width={20}
                    height={20}
                  />
                  <span className="text-outext-main">
                    {(gasFee)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
